import AutoDeliveryDcxPage from '@/containers/AutoDeliveryDcxPage/AutoDeliveryDcxPage';
import AutoDeliveryPage from '@/containers/AutoDeliveryPage/AutoDeliveryPage';
import autoDeliveryDcxService from '@/services/autoDeliveryDcxService';

const AutoDeliveryPageSwitcher = (props) => {
    const isDcx = autoDeliveryDcxService.getIsAutoDeliveryDcxEnabled();

    return isDcx ? <AutoDeliveryDcxPage {...props} /> : <AutoDeliveryPage {...props} />;
};

export default AutoDeliveryPageSwitcher;
